import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { RentalReservationStatusEnum } from '../enums/rental-reservation-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function rentalReservationStatusToColor(
	status: RentalReservationStatusEnum,
): string {
	switch (status) {
		case RentalReservationStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case RentalReservationStatusEnum.ACCEPTED:
			return RecordColorEnum.GREEN;

		case RentalReservationStatusEnum.REJECTED:
			return RecordColorEnum.RED;

		default:
			return RecordColorEnum.GRAY;
	}
}
